module.exports = __webpack_public_path__ + "static/media/youtube.0e412b9b.svg";